$(".profile-nav__link,.profile-nav__sublink").each(function (i,el) {
    if($(el).hasClass("_active")){
        $(".profile-nav__current").html($(el).html())
    }
})

$(".profile-nav__mob").click(function () {
    $(".profile-nav").toggleClass("_open")
})

$(".lk-filter__toggle").click(function () {
    $(this).toggleClass("_open")
    $(".lk-filter__bottom").slideToggle()
})

$(document).mouseup( function(e){
    var div = $( ".profile-nav" );
    if ( !div.is(e.target)
        && div.has(e.target).length === 0 ) {
        if($(div).hasClass("_open")){
            $(div).removeClass("_open")
        }
    }
});

let startDate = new Date;
let dateFields = document.querySelectorAll(".date-input")
dateFields.forEach(field => {
    new AirDatepicker(field, {
        locale: {
            days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
            daysShort: ['Вос', 'Пон', 'Вто', 'Сре', 'Чет', 'Пят', 'Суб'],
            daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
            months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            today: 'Сегодня',
            clear: 'Очистить',
            dateFormat: 'dd.MM.yyyy',
            timeFormat: 'HH:mm',
            firstDay: 1,
        },
        autoClose: true,
        // inline: true,
        // isMobile: true,
        startDate,
        // multipleDates: true ,
        // selectedDates: [startDate]
    })
})


